import React from 'react';
import styles from './index.css';

export default ({ pic, novel_name, author_name }) => (
    <div style={{
        textAlign: 'center',
        fontSize: '18px',
        lineHeight: '25px',
        paddingTop: '60px',
    }}>
        <div style={{
            width: '160px',
            height: '207px',
            backgroundImage: `url(${!pic ? '' : pic})`,
            backgroundSize: 'cover',
            backgroundPosition: 'center',
            margin: '0 auto',
        }}></div>
        <div style={{
            marginTop: '30px',
            fontSize: '26px',
            lineHeight: '37px',
        }}>{novel_name}</div>
        <div className={styles.light} style={{
            marginTop: '10px',
        }}>{author_name}</div>
        <div style={{
            marginTop: '91px',
        }}>本书由长歌中文网制作与发行</div>
        <div className={styles.light} style={{
            marginTop: '10px',
        }}>©版权所有 侵权必究</div>
    </div>
)



// WEBPACK FOOTER //
// ./src/layout/book/read/cover.js